import { PapiSellerDiscount } from '@wix/da-papi-types';

export const isDiscountActive = (discount: PapiSellerDiscount): boolean => {
  const now = new Date();
  const startDate = new Date(discount.startDate);
  const endDate = new Date(discount.endDate);

  return now >= startDate && now <= endDate;
};
export const isDiscountEnded = (discount: PapiSellerDiscount): boolean => {
  const now = new Date();
  const endDate = new Date(discount.endDate);

  return now > endDate;
};
